import { Link } from 'react-router-dom';
import type { Office, Page } from '../../lib/types';
import { useApiQuery } from '../../lib/useApi';
import { EmptyState, ErrorNote, Spinner } from '../../ui/components';

/** Standalone office picker for the lobby-TV board — no Shell chrome. */
export function TvPicker() {
  const officesQ = useApiQuery<Page<Office>>('/api/v1/servicedesk/offices?limit=100');

  return (
    <div className="min-h-screen bg-ink-950 px-8 py-10 text-white">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-1 text-2xl font-black">Queue Display</h1>
        <p className="mb-8 text-sm text-slate-400">Choose an office to show its "now serving" board.</p>

        {officesQ.error ? <ErrorNote message={officesQ.error} /> : null}
        {officesQ.loading ? (
          <Spinner label="Loading offices…" />
        ) : (officesQ.data?.items.length ?? 0) === 0 ? (
          <EmptyState title="No offices yet" />
        ) : (
          <div className="grid gap-3 sm:grid-cols-2">
            {officesQ.data!.items.map((o) => (
              <Link
                key={o.code}
                to={`/${'tv'}/${o.code}`}
                className="rounded-xl border border-ink-700 bg-ink-900 p-4 transition hover:border-brand-500 hover:bg-ink-800"
              >
                <div className="font-semibold text-white">{o.name}</div>
                <div className="mt-0.5 text-xs text-slate-400">
                  {o.island.replaceAll('_', ' ')} · {o.district}
                </div>
              </Link>
            ))}
          </div>
        )}

        <Link to="/counter" className="mt-10 inline-block text-sm font-semibold text-brand-100 underline">
          ← Back to console
        </Link>
      </div>
    </div>
  );
}
